import {
    Box,
    Button,
    ButtonBase,
    Collapse,
    ListItem,
    SvgIcon
} from '@mui/material'
import PropTypes from 'prop-types'
import { useCallback, useState } from 'react'
import { NavLink as RouterLink } from 'react-router-dom'
import ChevronDownIcon from '@/icons/ChevronDown'
import ChevronRightIcon from '@/icons/ChevronRight'

export const NavItem = (props) => {
    const {
        active,
        children,
        depth = 0,
        disabled,
        external,
        icon,
        label,
        open: openProp,
        path,
        title
    } = props
    const [open, setOpen] = useState(!!openProp)
    const handleToggle = useCallback(() => {
        setOpen((prevOpen) => !prevOpen)
    }, [])

    // Icons can be defined at top level only, deep levels have bullets instead of actual icons.

    let startIcon

    if (depth === 0) {
        startIcon = icon
    } else {
        startIcon = (
            <Box
                sx={{
                    alignItems: 'center',
                    display: 'center',
                    height: 20,
                    justifyContent: 'center',
                    width: 20
                }}
            >
                <Box
                    sx={[
                        {
                            backgroundColor: 'var(--nav-item-icon-color)',
                            borderRadius: '50%',
                            height: 4,
                            opacity: 0,
                            width: 4
                        },
                        active && {
                            backgroundColor:
                                'var(--nav-item-icon-active-color)',
                            height: 6,
                            opacity: 1,
                            width: 6
                        }
                    ]}
                />
            </Box>
        )
    }

    const offset = depth === 0 ? 0 : (depth - 1) * 16

    // Branch

    if (children) {
        return (
            <li>
                <ButtonBase
                    disabled={disabled}
                    onClick={handleToggle}
                    // sx={{
                    //     alignItems    : 'center',
                    //     display       : 'flex',
                    //     justifyContent: 'flex-start',
                    //     pl            : `${16 + offset}px`,
                    //     pr            : '16px',
                    //     py            : '6px',
                    //     textAlign     : 'left',
                    //     width         : '100%',
                    //     ...(active && {
                    //         ...(depth === 0 && {
                    //             backgroundColor: 'var(--nav-item-active-bg)'
                    //         })
                    //     }),
                    //     '&:hover': {
                    //         backgroundColor: 'var(--nav-item-hover-bg)'
                    //     }
                    // }}
                >
                    {/*{startIcon && (*/}
                    {/*    <Box*/}
                    {/*        component="span"*/}
                    {/*        sx={{*/}
                    {/*            alignItems    : 'center',*/}
                    {/*            color         : 'var(--nav-item-icon-color)',*/}
                    {/*            display       : 'inline-flex',*/}
                    {/*            justifyContent: 'center',*/}
                    {/*            mr            : 2,*/}
                    {/*            ...(active && {*/}
                    {/*                color: 'var(--nav-item-icon-active-color)'*/}
                    {/*            })*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        {startIcon}*/}
                    {/*    </Box>*/}
                    {/*)}*/}
                    <Box
                        component="span"
                        // sx={{
                        //     color     : 'var(--nav-item-color)',
                        //     flexGrow  : 1,
                        //     fontFamily: (theme) => theme.typography.fontFamily,
                        //     fontSize  : depth > 0 ? 13 : 14,
                        //     fontWeight: depth > 0 ? 500 : 600,
                        //     lineHeight: '24px',
                        //     whiteSpace: 'nowrap',
                        //     ...(active && {
                        //         color: 'var(--nav-item-active-color)'
                        //     }),
                        //     ...(disabled && {
                        //         color: 'var(--nav-item-disabled-color)'
                        //     })
                        // }}
                    >
                        {title}
                    </Box>
                    <SvgIcon
                        sx={{
                            color: 'var(--nav-item-chevron-color)',
                            fontSize: 16,
                            ml: 2
                        }}
                    >
                        {open ? <ChevronDownIcon /> : <ChevronRightIcon />}
                    </SvgIcon>
                </ButtonBase>
                <Collapse in={open} sx={{ mt: 0.5 }}>
                    {children}
                </Collapse>
            </li>
        )
    }

    // Leaf

    // eslint-disable-next-line no-nested-ternary
    const linkProps = path
        ? external
            ? {
                  component: 'a',
                  href: path,
                  target: '_blank'
              }
            : {
                  component: RouterLink,
                  to: path
              }
        : {}

    return (
        <li>
            <ButtonBase
                disabled={disabled}
                sx={[
                    {
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        pl: `${16 + offset}px`,
                        pr: '16px',
                        py: '6px',
                        textAlign: 'left',
                        width: '100%',
                        borderRadius: 1,
                        '&:hover': {
                            backgroundColor: 'var(--nav-item-hover-bg)'
                        }
                    },
                    active && {
                        backgroundColor: 'var(--nav-item-active-bg)'
                    }
                ]}
                {...linkProps}
            >
                {/*{startIcon && (*/}
                {/*    <Box*/}
                {/*        component="span"*/}
                {/*        sx={{*/}
                {/*            alignItems    : 'center',*/}
                {/*            color         : 'var(--nav-item-icon-color)',*/}
                {/*            display       : 'inline-flex',*/}
                {/*            justifyContent: 'center',*/}
                {/*            mr            : 2,*/}
                {/*            ...(active && {*/}
                {/*                color: 'var(--nav-item-icon-active-color)'*/}
                {/*            })*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        {startIcon}*/}
                {/*    </Box>*/}
                {/*)}*/}
                <Box
                    component="span"
                    sx={[
                        (theme) => ({
                            color: 'var(--nav-item-color)',
                            flexGrow: 1,
                            fontFamily: theme.typography.fontFamily,
                            lineHeight: '24px',
                            whiteSpace: 'nowrap'
                        }),
                        depth > 0
                            ? {
                                  fontSize: 13
                              }
                            : {
                                  fontSize: 14
                              },
                        depth > 0
                            ? {
                                  fontWeight: 500
                              }
                            : {
                                  fontWeight: 600
                              },
                        active && {
                            color: 'var(--nav-item-active-color)'
                        },
                        disabled && {
                            color: 'var(--nav-item-disabled-color)'
                        }
                    ]}
                >
                    {title}
                </Box>
                {label && (
                    <Box component="span" sx={{ ml: 2 }}>
                        {label}
                    </Box>
                )}
            </ButtonBase>
        </li>
    )
}

NavItem.propTypes = {
    active: PropTypes.bool,
    children: PropTypes.node,
    depth: PropTypes.number,
    disabled: PropTypes.bool,
    external: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.node,
    open: PropTypes.bool,
    path: PropTypes.string,
    title: PropTypes.string.isRequired
}
